const CopyToClipboardIcon = ({ iconStyle }) => {
  return (
    <svg
      className={iconStyle}
      width='21'
      height='21'
      viewBox='0 0 21 21'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M10.1339 20.4764H4.32977C1.7823 20.4764 0 18.6941 0 16.1467V8.89617C0 6.3487 1.7823 4.56641 4.32977 4.56641H7.90369C9.04212 4.56641 10.1619 5.03298 10.9644 5.83548L13.1946 8.05635C14.0064 8.86818 14.4637 9.97861 14.4637 11.117V16.1467C14.4637 18.6941 12.6814 20.4764 10.1339 20.4764ZM4.32977 5.96612C2.54747 5.96612 1.39971 7.11388 1.39971 8.89617V16.1467C1.39971 17.929 2.54747 19.0767 4.32977 19.0767H10.1339C11.9162 19.0767 13.064 17.929 13.064 16.1467V11.117C13.064 10.3425 12.7467 9.59603 12.2055 9.04548L9.97526 6.8246C9.42471 6.27405 8.66887 5.96612 7.90369 5.96612H4.32977Z'
        fill='#fff'
      />
      <path
        d='M15.7325 16.3334H13.7636C13.381 16.3334 13.0637 16.0162 13.0637 15.6336V11.1172C13.0637 10.3427 12.7465 9.59616 12.2053 9.0456L9.97506 6.82473C9.4245 6.27418 8.66866 5.96624 7.90349 5.96624H6.29849C5.9159 5.96624 5.59863 5.64898 5.59863 5.26639V4.74383C5.59863 2.19636 7.38093 0.414062 9.9284 0.414062H13.5023C14.6408 0.414062 15.7605 0.880632 16.563 1.68313L18.7932 3.91334C19.6144 4.7345 20.0623 5.81694 20.0623 6.97403V12.0037C20.0623 14.5511 18.28 16.3334 15.7325 16.3334ZM14.4635 14.9337H15.7325C17.5148 14.9337 18.6626 13.786 18.6626 12.0037V6.97403C18.6626 6.1902 18.3547 5.45302 17.8041 4.90246L15.5739 2.67226C15.0327 2.13104 14.2768 1.81377 13.5023 1.81377H9.9284C8.21142 1.81377 7.07299 2.88688 6.99834 4.56653H7.90349C9.04192 4.56653 10.1617 5.0331 10.9642 5.8356L13.1944 8.05648C14.0062 8.86831 14.4635 9.97874 14.4635 11.1172V14.9337Z'
        fill='#fff'
      />
    </svg>
  );
};

export default CopyToClipboardIcon;
